<template>
  <div @click="toplay(item)"
       class="item cursor-pointer">
    <img :src="item.CourseImage||item.ImageUrl" />
    <p class=" text-line1 font-size-22 font-color-22">
      {{item.CourseTitle||item.Title||item.VideoName}}</p>
    <div @click.stop="checkClick()"
         v-if="isEdit"
         class="check">
      <img v-if="item.check == true"
           class="check"
           src="../assets/pserson/check.png" />
      <img v-else
           class="check"
           src="../assets/pserson/uncheck.png" />
    </div>
    <div v-if="OrderBy == 2"
         class="morel">
      {{item.PlayCount}}
      <div class="play"></div>
      <div class="num"> {{item.PlayCount}}</div>
    </div>
    <div v-else-if="OrderBy == 3"
         class="morel">
      <div class="like"></div>
      <div class="num"> {{item.LikeCount}}</div>
    </div>
    <div v-else-if="OrderBy == 4"
         class="morel">
      <div class="shaer"></div>
      <div class="num"> {{item.ShareCount}}</div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'courseItem',
  data () {
    return {

    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    OrderBy: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: {},
    }

  },

  computed: {
    isCheck () {
      return this.item.check;
    }
  },
  methods: {
    checkClick () {
      this.$set(this.item, "check", !this.item.check)

    },
    toplay (item) {

      let routeData = this.$router.resolve({
        name: 'video',
        params: {
          cateId: item.CatalogId,
          Id: item.CourseId || item.Id,
          videoId: item.VideoId || 0,
        }
      })
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style scoped>
.item {
  width: 3.15rem;
  height: 2.84rem;
  background: #ffffff;
  /* box-shadow: 0px 0px 0.38rem 0px rgba(188, 188, 188, 0.35); */
  box-shadow: 0 0 0.22rem 0.05rem rgba(222, 222, 222, 0.2);
  border-radius: 0.1rem;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.item img:hover {
  transform: scale(1.1);
  transition: all 0.3s;
}

.item img {
  width: 3rem;
  height: 2rem;
  margin-top: 0.1rem;
  position: relative;
  display: block;
  overflow: hidden;
  transition: all 0.3s;
}

.item p {
  width: 3rem;
  margin-top: 0.24rem;
  text-align: center;
  line-height: 0.3rem;
}

.item p:hover {
  color: #0cb4a2;
}

.item .check {
  z-index: 3;
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  width: 0.34rem;
  height: 0.34rem;
}

.item .check img {
  width: 0.34rem;
  height: 0.34rem;
}

.item .morel {
  min-width: 0.8rem;

  height: 0.3rem;
  padding: 0 0.2rem;

  background: #fff;
  border-radius: 0.13rem;
  position: absolute;
  display: flex;
  align-items: center;
  right: 0.1rem;
  top: 1.7rem;
  z-index: 2;
}
.item .morel .shaer {
  width: 0.12rem;
  height: 0.12rem;
  margin-right: 0.1rem;
  background-size: 0.12rem 0.12rem;
  background-repeat: no-repeat;
  background-image: url(../assets/pserson/shaer1.png);
}
.item .morel .like {
  width: 0.12rem;
  height: 0.12rem;
  margin-right: 0.1rem;
  background-size: 0.12rem 0.12rem;
  background-repeat: no-repeat;
  background-image: url(../assets/pserson/like1.png);
}
.item .morel .play {
  width: 0.12rem;
  height: 0.12rem;
  margin-right: 0.1rem;
  background-size: 0.12rem 0.12rem;
  background-repeat: no-repeat;
  background-image: url(../assets/pserson/play.png);
}
.item .morel .num {
  color: #f40;
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 0.2rem;
  text-align: center;
}
.item .morel:hover {
  color: #fff;
  background: #f40;
}
.item .morel:hover .shaer {
  width: 0.12rem;
  height: 0.12rem;
  margin-right: 0.1rem;
  background-size: 0.12rem 0.12rem;
  background-repeat: no-repeat;
  background-image: url(../assets/pserson/shaer.png);
}
.item .morel:hover .like {
  width: 0.12rem;
  height: 0.12rem;
  margin-right: 0.1rem;
  background-size: 0.12rem 0.12rem;
  background-repeat: no-repeat;
  background-image: url(../assets/pserson/like.png);
}
.item .morel:hover .play {
  width: 0.12rem;
  height: 0.12rem;
  margin-right: 0.1rem;
  background-size: 0.12rem 0.12rem;
  background-repeat: no-repeat;
  background-image: url(../assets/pserson/play1.png);
}
.item .morel:hover .num {
  color: #fff;
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 0.2rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/courseItem.vue